import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ExistingPacket } from "@models/mips-stepper.model";

interface SubmissionActionsParams extends ICellRendererParams {
  onContinue: (packet: ExistingPacket) => void;
  onDelete: (packet: ExistingPacket) => void;
  isContinueBlocked: (packet: ExistingPacket) => boolean;
  isEditable: (packet: ExistingPacket) => boolean;
}

@Component({
  selector: "app-submission-actions-renderer",
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="actions-cell">
      <button
        mat-button
        color="primary"
        [disabled]="continueBlocked"
        [matTooltip]="continueBlocked ? 'A group submission has already been submitted for this TIN' : ''"
        (click)="continue()"
      >
        @if (!editable) {
          <mat-icon>visibility</mat-icon>
        }
        {{ editable ? 'Continue' : 'View' }}
      </button>
      @if (packet?.status !== 'submitted') {
        <button
          mat-icon-button
          color="warn"
          (click)="delete()"
          aria-label="Delete submission"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  `,
  styles: [
    `.actions-cell { display: flex; align-items: center; gap: 4px; white-space: nowrap; }`,
  ],
})
export class SubmissionActionsRendererComponent
  implements ICellRendererAngularComp
{
  private params!: SubmissionActionsParams;

  get packet(): ExistingPacket | null {
    return this.params?.data ?? null;
  }

  get continueBlocked(): boolean {
    return !!this.packet && this.params.isContinueBlocked(this.packet);
  }

  get editable(): boolean {
    return !!this.packet && this.params.isEditable(this.packet);
  }

  agInit(params: SubmissionActionsParams): void {
    this.params = params;
  }

  refresh(params: SubmissionActionsParams): boolean {
    this.params = params;
    return true;
  }

  continue(): void {
    if (this.packet && !this.continueBlocked) {
      this.params.onContinue(this.packet);
    }
  }

  delete(): void {
    if (this.packet) {
      this.params.onDelete(this.packet);
    }
  }
}
